export { encode } from './encode.js';
export { decode } from './decode.js';
//# sourceMappingURL=index.js.map